import NProgress from 'nprogress';

const NProgressApp = NProgress.configure({
  parent: '#nprogress-container',
  showSpinner: false,
  minimum: 0.3,
  trickleSpeed: 100
});
export { NProgressApp as default };
